import React from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import { AppShell } from '../components/layout/AppShell.js';
import { LoginPage } from '../features/auth/LoginPage.js';
import { DashboardPage } from '../features/dashboard/DashboardPage.js';
import { UsersPage } from '../features/users/UsersPage.js';
import { UserDetailPage } from '../features/users/UserDetailPage.js';
import { DevicesPage } from '../features/devices/DevicesPage.js';
import { DeviceDetailPage } from '../features/devices/DeviceDetailPage.js';
import { CommandsPage } from '../features/commands/CommandsPage.js';
import { RemoteConfigPage } from '../features/config/RemoteConfigPage.js';
import { FeatureFlagsPage } from '../features/features/FeatureFlagsPage.js';
import { SubscriptionsPage } from '../features/subscriptions/SubscriptionsPage.js';
import { EntitlementsPage } from '../features/entitlements/EntitlementsPage.js';
import { SnapshotsPage } from '../features/snapshots/SnapshotsPage.js';
import { AuditLogsPage } from '../features/audit/AuditLogsPage.js';
import { SystemHealthPage } from '../features/system/SystemHealthPage.js';
import { NotFoundPage, ForbiddenPage } from '../components/ui/StatusPages.js';

export const router = createBrowserRouter([
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/',
    element: <Navigate to="/admin" replace />,
  },
  {
    path: '/admin',
    element: <AppShell />,
    children: [
      {
        index: true,
        element: <DashboardPage />,
      },
      {
        path: 'users',
        element: <UsersPage />,
      },
      {
        path: 'users/:userId',
        element: <UserDetailPage />,
      },
      {
        path: 'devices',
        element: <DevicesPage />,
      },
      {
        path: 'devices/:deviceId',
        element: <DeviceDetailPage />,
      },
      {
        path: 'commands',
        element: <CommandsPage />,
      },
      {
        path: 'commands/:commandId',
        element: <CommandsPage />,
      },
      {
        path: 'config',
        element: <RemoteConfigPage />,
      },
      {
        path: 'features',
        element: <FeatureFlagsPage />,
      },
      {
        path: 'subscriptions',
        element: <SubscriptionsPage />,
      },
      {
        path: 'entitlements',
        element: <EntitlementsPage />,
      },
      {
        path: 'snapshots',
        element: <SnapshotsPage />,
      },
      {
        path: 'snapshots/:snapshotId',
        element: <SnapshotsPage />,
      },
      {
        path: 'audit',
        element: <AuditLogsPage />,
      },
      {
        path: 'system',
        element: <SystemHealthPage />,
      },
      {
        path: 'forbidden',
        element: <ForbiddenPage />,
      },
      {
        path: '*',
        element: <NotFoundPage />,
      },
    ],
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
]);
